export default __webpack_public_path__ + "static/media/shopmart.356a8191.png";